export default __webpack_public_path__ + "static/media/library-grey.40772bd7.svg";